export const TemplatePostTypeIds: {[key: string]: number} = {
  instagramSquare: 0,
  instagramStory: 1,
  facebookTimeline: 2,
  pubTV: 3,
  instagramPortrait: 4,
  posterA4: 5,
};
